import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useVoterAuth } from '../contexts/VoterAuthContext';

export default function Confirmation() {
  const { voter } = useVoterAuth();
  const navigate = useNavigate();
  const [receipt, setReceipt] = useState(null);

  useEffect(() => {
    if (!voter) { navigate('/vote/login'); return; }
    const stored = localStorage.getItem('vote_receipt');
    if (!stored) { navigate('/vote/dashboard'); return; }
    setReceipt(JSON.parse(stored));
  }, [voter, navigate]);

  if (!receipt) return <div className="loading">Loading...</div>;

  return (
    <div className="dashboard-container">
      <div className="confirmation-box">
        <div className="success-icon">&#10003;</div>
        <h1>Vote Confirmed!</h1>
        <p>Your vote has been successfully recorded.</p>
        <div className="receipt-card">
          <h2>Vote Receipt</h2>
          <div className="receipt-row">
            <span>Candidate:</span>
            <strong>{receipt.candidate_name}</strong>
          </div>
          <div className="receipt-row">
            <span>Receipt Code:</span>
            <strong className="receipt-code">{receipt.receipt_code}</strong>
          </div>
          <div className="receipt-row">
            <span>Vote ID:</span>
            <strong>{receipt.vote_id}</strong>
          </div>
        </div>
        <p className="receipt-note">Please keep your receipt code for your records.</p>
        <Link to="/vote/dashboard" className="btn-primary">Back to Dashboard</Link>
      </div>
    </div>
  );
}
